import { createAction } from "redux-actions";
import {
  IAdvanceClusterAggregationResponse,
  IAdvanceClusterFacetsResponse,
  IClusterAggregationResponse,
  IClusterFacetsResponse,
  ICollection,
  ICollectionAggregateData,
  IPaginated,
  IPublishedAggregationResponse,
  IRecommendationConfig,
  IRecommendationSearchResults,
  ISingleProductRecommendation,
} from "../../types";
import { IActions } from "./collection.reducer";

// Action Helpers
const ACTION_PREFIX = "@collection";

const getActionName = (name: string) => {
  return `${ACTION_PREFIX}/${name}`;
};
const getDataAction = <T>(name: string): IActions<T> => {
  return ({
    reset: createAction(getActionName(`${name}_RESET`)),
    init: createAction(getActionName(`${name}_INIT`)),
    failed: createAction(getActionName(`${name}_FAILED`)),
    success: createAction<T>(getActionName(`${name}_SUCCESS`)),
  } as unknown) as IActions<T>;
};

// Actions Name
export const GET_COLLECTIONS_ACTION = getDataAction<string[]>("LIST");
export const SELECT_COLLECTION_ACTION = getDataAction<ICollection>(
  "SELECTED_COLLECTION"
);
export const GET_AGGREGATED_DATA_ACTION = getDataAction<
  ICollectionAggregateData[]
>("AGGREGATED_DATA");

export const PUBLISH_AGGREGATION_ACTION = getDataAction<
  IPublishedAggregationResponse
>("PUBLISH_AGGREGATION");

export const CLUSTER_AGGREGATION_ACTION = getDataAction<
  IClusterAggregationResponse
>("CLUSTER_AGGREGATION");

export const GET_CLUSTER_FACETS_ACTION = getDataAction<IClusterFacetsResponse>(
  "CLUSTER_FACETS"
);

export const GET_ADVANCE_CLUSTER_AGGREGATION_ACTION = getDataAction<
  IAdvanceClusterAggregationResponse
>("ADVANCE_CLUSTER_AGGREGATION");

export const GET_ADVANCE_CLUSTER_FACETS_ACTION = getDataAction<
  IAdvanceClusterFacetsResponse
>("ADVANCE_CLUSTER_FACETS");

export const AGGREGATION_PAGINATED_ACTION = createAction<
  IPaginated<ICollectionAggregateData[]>
>(getActionName("PAGINATED_AGGREGATED_DATA"));

export const SINGLE_RECOMMENDATION_ACTION = getDataAction<
  ISingleProductRecommendation
>(getActionName("SINGLE_RECOMMENDATION"));

export const RECOMMENDATION_CONFIG_ACTION = createAction<IRecommendationConfig>(
  getActionName("RECOMMENDATION_CONFIG")
);

export const RECOMMENDATION_SEARCH_RESULTS_ACTION = getDataAction<
  IRecommendationSearchResults
>(getActionName("RECOMMENDATION_SEARCH_RESULTS"));
